import http from '../_http_v2';

const detect = {
  //default
  list: (m) => { return http.post(`console/webcastle/detect/list`, m); },
  detail: (m) => { return http.get(`console/webcastle/detect/${m.id}`); },

  //crud
  insert: (m) => { return http.post(`console/webcastle/detect`, m); },
  update: (m) => { return http.put(`console/webcastle/detect`, m); },
  delete: (m) => { return http.delete(`console/webcastle/detect/${m.id}`); },

  //summary.geo
  geo: (m) => { return http.post(`console/webcastle/detect/geo`, m); },

  //policy.summary
  policy: (m) => { return http.get(`console/webcastle/detect/policy/${m.id}`, m); },

  //exception
  exceptionAdd: (m) => { return http.put(`console/webcastle/detect/exception/add`, m); },
  exceptionDelete: (m) => { return http.put(`console/webcastle/detect/exception/delete`, m); },

  //download
  download: (m) => { return http.post(`console/webcastle/detect/download`, m); }
}

export default detect